import {
    CREATE_GENERAL_INWARD_FAILURE_DK,
    CREATE_GENERAL_INWARD_REQUEST_DK,
    CREATE_GENERAL_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_GENERAL_INWARD_DK,
    FETCH_SINGLE_GENERAL_INWARD_FAILURE_DK,
    FETCH_SINGLE_GENERAL_INWARD_REQUEST_DK,
    FETCH_SINGLE_GENERAL_INWARD_SUCCESS_DK,
    FETCH_GENERAL_INWARD_FAILURE_DK,
    FETCH_GENERAL_INWARD_REQUEST_DK,
    FETCH_GENERAL_INWARD_SUCCESS_DK,
    NAVIGATE_GENERAL_INWARD_DETAILS_DK,
    NAVIGATE_GENERAL_INWARD_DK,
    GENERAL_INWARD_USERFORM_RESET_DK,
    UPDATE_GENERAL_INWARD_FAILURE_DK,
    UPDATE_GENERAL_INWARD_REQUEST_DK,
    UPDATE_GENERAL_INWARD_SUCCESS_DK,
    DELETE_GENERAL_INWARD_REQUEST_DK,
    DELETE_GENERAL_INWARD_SUCCESS_DK,
    DELETE_GENERAL_INWARD_FAILURE_DK,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_GENERAL_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_GENERAL_INWARD_ID_DK
} from './generalInward.actionsType';

export const GENERAL_INWARD_DK = 'generalInwardDK';

let initialState = {
    loading: false,
    generalInward: [],
    pendingGeneralInward: [],
    activeKey: 1,
    generalInwardId: '',
    generalInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldRoundoff: 0
    },
    selectedTeam: {},
    isGeneralInward: false,
    generalInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let generalInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_GENERAL_INWARD_REQUEST_DK:
        case FETCH_PENDING_GENERAL_PO_IN_INWARD_REQUEST_DK:
        case CREATE_GENERAL_INWARD_REQUEST_DK:
        case FETCH_SINGLE_GENERAL_INWARD_REQUEST_DK:
        case UPDATE_GENERAL_INWARD_REQUEST_DK:
        case DELETE_GENERAL_INWARD_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInward: updatePayload
            };
        case FETCH_PENDING_GENERAL_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingGeneralInward: updatePayload
            };
        case CREATE_GENERAL_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                generalInwardId: updatePayload[0]?.fldID,
                activeKey: updatePayload[0]?.fldID && payload ? 2 : 1
            };
        case FETCH_SINGLE_GENERAL_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                generalInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_GENERAL_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                generalInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case DELETE_GENERAL_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                generalInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                }
            };
        case FETCH_GENERAL_INWARD_FAILURE_DK:
        case FETCH_PENDING_GENERAL_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_GENERAL_INWARD_FAILURE_DK:
        case CREATE_GENERAL_INWARD_FAILURE_DK:
        case UPDATE_GENERAL_INWARD_FAILURE_DK:
        case DELETE_GENERAL_INWARD_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GENERAL_INWARD_DK:
            return {
                ...state,
                loading: false,
                generalInwardForm: {
                    ...state.generalInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_GENERAL_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case GENERAL_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                generalInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {},
                generalInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_GENERAL_INWARD_ID_DK:
            return {
                ...state,
                generalInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_GENERAL_INWARD_DETAILS_DK:
            return {
                ...state,
                isGeneralInward: true,
                generalInwardSelectedValue: updatePayload.generalInwardSelectedValue
            };
        case NAVIGATE_GENERAL_INWARD_DK:
            return {
                ...state,
                isGeneralInward: false
            };
        default:
            return state;
    }
};
